module.exports = __webpack_public_path__ + "static/img/OptimizeBusiness.f5c2eaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-v2/OptimizeBusiness.png
// module id = Rc7P
// module chunks = 44